import { LayoutTemplateContainer } from '../../_layouts/LayoutsEditTemplate';

import { useInquiry } from './InquiryProvider';
import { useToast } from '@/hooks/V3/useToast';
import { Header, Body, Controller } from '../reviews/AddOrEditTemplate';

interface TemplateProps {
  title: string;
  setTitle: (v: string) => void;
  content: string;
  setContent: (v: string) => void;
  onBack: () => void;
  mode: 'add' | 'edit';
  editTemplateNo?: number | null;
}

export const AddOrEditTemplate = ({
  title,
  setTitle,
  content,
  setContent,
  onBack,
  mode,
  editTemplateNo,
}: TemplateProps) => {
  const { handleAddOrEditTemplate, refetchTemplateList, isTemplateSaving, isTemplateDeleting } =
    useInquiry();
  const { showToast } = useToast();

  // 등록/수정
  const handleSubmit = () => {
    if (!title.trim() || !content.trim()) return;
    const params = {
      TemplateNo: mode === 'add' ? 0 : editTemplateNo ?? 0,
      Title: title,
      Content: content,
      UseYn: 'Y',
    };
    handleAddOrEditTemplate(params, () => {
      showToast('success', mode === 'add' ? '템플릿이 추가되었어요' : '템플릿이 수정되었어요');
      onBack();
    });
  };

  // 삭제
  const handleDelete = () => {
    if (!editTemplateNo) return;
    const params = {
      TemplateNo: editTemplateNo,
      UseYn: 'N',
    };
    handleAddOrEditTemplate(params, () => {
      showToast('success', '템플릿이 삭제되었어요');
      refetchTemplateList();
      onBack();
    });
  };

  // 입력값이 모두 채워져야만 등록/수정 가능
  const isSubmitDisabled =
    !title.trim() || !content.trim() || isTemplateSaving || isTemplateDeleting;

  return (
    <LayoutTemplateContainer>
      <div className="flex flex-1 flex-col gap-[12px]">
        <Header mode={mode} onBack={onBack} />
        <Body title={title} setTitle={setTitle} content={content} setContent={setContent} />
      </div>
      <Controller
        mode={mode}
        onSubmit={handleSubmit}
        onDelete={handleDelete}
        onCancel={onBack}
        isLoading={isTemplateSaving || isTemplateDeleting}
        isSubmitDisabled={isSubmitDisabled}
      />
    </LayoutTemplateContainer>
  );
};
